import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { PACKAGE_NAME, TEAM_NAME } from '../../common/constants.tsx';
import type { State, TourState } from '../../types.tsx';

export type SetTourState = (tourState: TourState) => Promise<void>;

const getUrl = () => '/rest/servicedesk/onboarding/latest/fsf';

const putTourState = async (tourState: TourState): Promise<void> => {
	const url = getUrl();
	const response = await fetch(url, {
		...getDefaultOptions(url),
		method: 'PUT',
		body: JSON.stringify(tourState),
	});

	if (!response.ok) {
		const text = await response.text();
		const error = new FetchError(response.status, text);
		fireErrorAnalytics({
			error,
			meta: {
				id: 'setTourState_responseNotOK',
				packageName: PACKAGE_NAME,
				teamName: TEAM_NAME,
			},
			attributes: {
				message: error.message,
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};

export const setTourState =
	(): Action<State> =>
	({ setState }): SetTourState =>
	// @ts-expect-error - TS2322 - Type 'SetTourState' is not assignable to type 'void | Promise<void>'.
	async (tourState: TourState) => {
		setState({ error: undefined, data: tourState, isLoading: true });

		try {
			await putTourState(tourState);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'setTourState',
					packageName: PACKAGE_NAME,
					teamName: TEAM_NAME,
				},
				sendToPrivacyUnsafeSplunk: true,
			});
			setState({
				error,
			});
			throw error;
		} finally {
			setState({
				isLoading: false,
			});
		}
	};
